import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  Popover,
  Drawer,
  Space,
  message,
  Modal,
  Divider,
  Table,
  Tooltip,
} from "antd";
import { saveAs } from "file-saver";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import DataTable, { pageSizeKey } from "../../helper/dataTable/dataTable";
import {
  SearchOutlined,
  MoreOutlined,
  PrinterOutlined,
  LinkOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
  PartitionOutlined,
} from "@ant-design/icons";
import Printing from "../../helper/Print/Printing";
import {
  getOrdersReport,
  getOrderHtml,
  getOrdersXls,
  getOrdersPdf,
} from "../../../services/Reports/ReportService";
import FilterOrdersRep from "../../helper/Modal/FilterOrdersRep";
import { LanguageContext } from "../../../languages/Language";
import _t from "../../../languages/translate";

const OrderReport = () => {
  let location = useLocation();
  const { userLanguage } = useContext(LanguageContext);
  const [dataSource, setDataSource] = useState([]);
  const [columns, setColumns] = useState([]);
  const [hasDetails, setHasDetails] = useState(false);
  const [detailColumns, setDetailColumns] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [meta, setMeta] = useState({});
  const [html, setHtml] = useState("");
  const [reportFilter, setReportFilter] = useState({});
  const [loadData, setLoadData] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visiblePrDrawer, setVisiblePrDrawer] = useState(false);
  const [objSearchState, setObjSearchState] = useState(null);
  const savedPageSize = localStorage.getItem(pageSizeKey);

  const handelLinkDataObj = () => {
    let dataObj = JSON.parse(localStorage.getItem("linkObj"));
    setObjSearchState(dataObj);
    localStorage.removeItem("linkObj");
  };

  useEffect(() => {
    const fetchData = async () => {
      if (localStorage.getItem("linkObj") !== null) {
        handelLinkDataObj();
      }

      const query = new URLSearchParams(location.search);
      if (savedPageSize && !query.has(pageSizeKey))
        query.set(pageSizeKey, savedPageSize);
      try {
        setLoadData(true);

        if (objSearchState !== null) {
          const { data: responce } = await getOrdersReport(
            query.toString(),
            objSearchState
          );

          if (responce.data.dataSource.length > 0) {
            setColumns(responce.data.columns);
            setDetailColumns(responce.data.detailColumns);
            setDataSource(responce.data.dataSource);
            setReportFilter(responce.data.reportFilter);
            setMeta(responce.meta);
          } else {
            setDataSource([]);
            message.info(_t("msgThereIsNoData"), 3);
          }
        }
      } catch (error) {
        if (error.response) {
          message.error(
            error.response.data?.message || _t("msgUnknownError"),
            3
          );
        } else if (error.request) {
          message.error(_t("msgServerDisconnected"), 3);
        } else {
          message.error(_t("msgUnknownError"), 3);
        }
      } finally {
        setLoadData(false);
      }
    };

    fetchData();
  }, [
    location.search,
    savedPageSize,
    objSearchState,
    setDataSource,
    setMeta,
    setLoadData,
  ]);

  const onClosePrDrawer = () => {
    setVisiblePrDrawer(false);
  };

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  //**.start >> Drawing links ********************
  const linksColumns = [
    {
      key: "reportTempMenu",
      align: "center",
      title: <LinkOutlined />,
      width: 40,
      fixed: "left",
      render: (item) => {
        return item.reportTempMenu.length !== 0 ? (
          <Popover placement="bottomRight" content={() => linkCont(item)}>
            <Button
              type="link"
              icon={<MoreOutlined style={{ color: "#3a7df2", fontSize: 16 }} />}
            />
          </Popover>
        ) : undefined;
      },
    },
  ];

  const linkCont = (item) => (
    <div>
      {item.reportTempMenu.map((e) =>
        e.type === 0 ? (
          <p key={e.key}>
            <Link target="_blank" rel="noopener noreferrer" to={e.url}>
              <label style={{ cursor: "pointer" }}>{e.name}</label>
            </Link>
          </p>
        ) : (
          <p key={e.key}>
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to={e.url}
              onClick={() => handelLinkObj(item, e.reportKey)}
            >
              <label style={{ cursor: "pointer" }}>{e.name}</label>
            </Link>
          </p>
        )
      )}
    </div>
  );

  const handelLinkObj = (item, repKey) => {
    let obj = {
      reportFilter: reportFilter,
      row: JSON.stringify(item),
      reportKey: repKey,
      timeShift: new Date().getTimezoneOffset(),
    };
    localStorage.setItem("linkObj", JSON.stringify(obj));
  };
  //**.end >> Drawing links ********************

  const handelOrderRep = async (data) => {
    setLoadData(true);
    setHasDetails(data.reportFilter.showDetails);
    data.columns = columnsToObject();
    setObjSearchState(data);
    setVisible(false);
  };

  const columnsToObject = () => {
    const savedColumns = localStorage.getItem("OrderRep");
    const parsedColumns = savedColumns && JSON.parse(savedColumns);
    const filteredColumns = Array.isArray(parsedColumns)
      ? parsedColumns.filter(
          (c) => c.key !== "edit" && c.key !== "reportTempMenu"
        )
      : columns;
    return filteredColumns;
  };

  const onPrint = async (obj) => {
    try {

     // 
   // console.log(expandedRowKeys);


      obj.columns = columnsToObject();
      const query = new URLSearchParams(location.search);
      const data = await getOrderHtml(
        query.toString(),
        obj,
        userLanguage === "ar" ? 0 : 1
      );
      setHtml(data.data);
      setVisiblePrDrawer(true);
    } catch (error) {
      if (error.response) {
        message.error(error.response.data?.message || _t("msgUnknownError"), 3);
      } else if (error.request) {
        message.error(_t("msgServerDisconnected"), 3);
      } else {
        message.error(_t("msgUnknownError"), 3);
      }
    } finally {
      setLoadData(false);
    }
  };

  const onExportToExc = async (obj) => {
    const hide = message.loading(_t("strDataExporting"), 0);
    try {
      obj.columns = columnsToObject();
      const query = new URLSearchParams(location.search);

      const { data, headers } = await getOrdersXls(
        query.toString(),
        obj,
        userLanguage === "ar" ? 0 : 1
      );
      const byteCharacters = atob(data.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      saveAs(blob, "OrderReport.xlsx");
    } catch (error) {
      if (error.response) {
        message.error(error.response.data?.message || _t("msgUnknownError"), 3);
      } else if (error.request) {
        message.error(_t("msgServerDisconnected"), 3);
      } else {
        message.error(_t("msgUnknownError"), 3);
      }
    } finally {
      setTimeout(hide);
    }
  };

  const onExportToPDF = async (obj) => {
    const hide = message.loading(_t("strDataExporting"), 0);
    try {
      obj.columns = columnsToObject();
      const query = new URLSearchParams(location.search);

      const { data, headers } = await getOrdersPdf(
        query.toString(),
        obj,
        userLanguage === "ar" ? 0 : 1
      );
      const byteCharacters = atob(data.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      saveAs(blob, "OrderReport.pdf");
    } catch (error) {
      if (error.response) {
        message.error(error.response.data?.message || _t("msgUnknownError"), 3);
      } else if (error.request) {
        message.error(_t("msgServerDisconnected"), 3);
      } else {
        message.error(_t("msgUnknownError"), 3);
      }
    } finally {
      setTimeout(hide);
    }
  };

  const expandedRowRender = (reqord) => {
    const data = [...reqord.details];
    if (data.length)
      return (
        <Table
          columns={[...linksColumns, ...detailColumns]}
          dataSource={data}
          pagination={{
            hideOnSinglePage: true,
            size: "small",
            showSizeChanger: false,
          }}
        />
      );
    return false;
  };

  const isRowExpandable = (reqord) => !!reqord.details?.length;

  const customExpandIcon = (props) => {
    if (props.record?.details?.length < 1) {
      return <span></span>;
    }
    if (props.expanded) {
      return (
        <button
          type="button"
          className="ant-table-row-expand-icon ant-table-row-expand-icon-expanded"
          onClick={(e) => {
            props.onExpand(props.record, e);
          }}
        />
      );
    } else {
      return (
        <button
          type="button"
          className="ant-table-row-expand-icon ant-table-row-expand-icon-collapsed"
          onClick={(e) => {
            props.onExpand(props.record, e);
          }}
        />
      );
    }
  };

  const expandAll = (
    <>
      <Tooltip
        placement="topLeft"
        title={_t("strShowAllDetails")}
        color="#2db7f5"
      >
        <PartitionOutlined
          style={{ fontSize: 16, marginTop: 5 }}
          onClick={() => {
            setExpandedRowKeys(
              expandedRowKeys.length === dataSource.length
                ? []
                : dataSource.map((d) => d.invId)
            );
          }}
        />
      </Tooltip>
      <Divider type="vertical" />
    </>
  );

  return (
    <>
      <Drawer
        width={720}
        onClose={onClosePrDrawer}
        visible={visiblePrDrawer}
        title={_t("strPrintPreview")}
      >
        <Printing htmlRep={html} />
      </Drawer>
      <Modal
        title={_t("strOrderReport")}
        visible={visible}
        onCancel={() => onClose()}
        footer={null}
        width={800}
      >
        <FilterOrdersRep
          onFilterData={objSearchState !== null ? objSearchState : undefined}
          onHandelData={(data) => handelOrderRep(data)}
        />
      </Modal>
      <DataTable
        loading={loadData}
        hideSearch
        rowKey="invId"
        dataSource={dataSource}
        columns={[...linksColumns, ...columns]}
        expandIconColumnIndex={0}
        rowExpandable={isRowExpandable}
        expandedRowRender={hasDetails && expandedRowRender}
        saveColumnsProps="OrderRep"
        expandedRowKeys={expandedRowKeys}
        extraActions={expandAll}
        expandIcon={(x) => customExpandIcon(x)}
        onExpand={(expanded, record) => {
          if (!expanded)
            setExpandedRowKeys((state) =>
              state.filter((e) => e !== record.invId)
            );
          else setExpandedRowKeys((state) => [...state, record.invId]);
        }}
        rowClassName={(record, index) =>
          record.rowType === "First"
            ? "firstActive-row"
            : record.rowType === "Total"
            ? "active-row"
            : index % 2 === 0
            ? "table-row-light"
            : "table-row-dark"
        }
        meta={meta}
        bordered
        extra={
          <Space size="small">
            <Button
              size="small"
              type="primary"
              onClick={showDrawer}
              style={{ width: 150, borderRadius: 5 }}
              icon={<SearchOutlined />}
            >
              {_t("strSearch")}
            </Button>
            <Divider type="vertical" />
            <Button
              onClick={() => onPrint(objSearchState)}
              size="small"
              type="link"
              style={{
                width: 100,
                borderRadius: 5,
              }}
              icon={<PrinterOutlined />}
              disabled={dataSource.length !== 0 ? false : true}
            >
              {" "}
              {_t("strPrint")}
            </Button>
            <Divider type="vertical" />
            <Button
              size="small"
              onClick={() => {
                onExportToExc(objSearchState);
              }}
              type="link"
              style={{ width: 100, borderRadius: 5 }}
              disabled={dataSource.length !== 0 ? false : true}
              icon={<FileExcelOutlined style={{ fontSize: 16 }} />}
            >
              {_t("strExportToExcel")}
            </Button>
            <Divider type="vertical" />
            <Button
              size="small"
              onClick={() => {
                onExportToPDF(objSearchState);
              }}
              type="link"
              style={{ width: 100, borderRadius: 5 }}
              disabled={dataSource.length !== 0 ? false : true}
              icon={<FilePdfOutlined style={{ fontSize: 16 }} />}
            >
              {_t("strExportToPDF")}
            </Button>
          </Space>
        }
      />
    </>
  );
};

export default OrderReport;
